import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { api } from "../lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) { setCurrent(""); setNext(""); setConfirm(""); }
  }, [open]);

  const submit = async (e) => {
    e?.preventDefault();
    if (!current || !next) return toast.error("Fill in all fields");
    if (next.length < 4) return toast.error("New password is too short");
    if (next !== confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.changePassword(current, next);
      toast.success("Password updated");
      onOpenChange(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not change password");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-serif text-2xl text-[#082D4A]"><KeyRound size={20} /> Change password</DialogTitle>
          <DialogDescription>Update your own password. You'll stay signed in.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 py-2">
          <div className="space-y-1.5">
            <Label>Current password</Label>
            <Input type="password" data-testid="current-password-input" value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus />
          </div>
          <div className="space-y-1.5">
            <Label>New password</Label>
            <Input type="password" data-testid="new-password-input" value={next} onChange={(e) => setNext(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label>Confirm new password</Label>
            <Input type="password" data-testid="confirm-password-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={busy} data-testid="change-password-submit" className="w-full bg-[#082D4A] text-white hover:bg-[#08223A]">
              {busy ? "Updating…" : "Update password"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
